import { Box } from '@mui/material';
import MediaGridItemSkeleton from './MediaGridItemSkeleton';
import MediaGridItem from './MediaGridItem';

const MediaGrid = ({ media, isLoading, onSelect, selectedItems }) => {
  return (
    <Box className="w-full h-full overflow-y-auto">
      <Box className="flex flex-wrap gap-2 w-full ">
        {isLoading ? (
          <>
            {Array(20).map((i) => (
              <MediaGridItemSkeleton key={i} />
            ))}
          </>
        ) : (
          <>
            {media.map((item) => (
              <MediaGridItem
                key={item.id}
                item={item}
                src={item.thumbnailUrl || item.temporaryUrl}
                onClick={onSelect}
                selected={Boolean(
                  selectedItems?.findIndex(
                    (selected) => selected.id === item.id
                  ) != -1
                )}
              />
            ))}
          </>
        )}
      </Box>
    </Box>
  );
};
export default MediaGrid;
